/**
 * Generated by orval v6.12.1 🍺
 * Do not edit manually.
 * Platz API
 * Platz API boi
 * OpenAPI spec version: 2.0
 */

export type SourceBaseViewType =
  (typeof SourceBaseViewType)[keyof typeof SourceBaseViewType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SourceBaseViewType = {
  googled_lyrics: "googled_lyrics",
  openai_chat: "openai_chat",
  youtube_transcript: "youtube_transcript",
  text: "text",
} as const;
